module.exports = __webpack_public_path__ + "images/external_images/svg/components/signout-dark-icon.svg";